import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS, BOOKING_URL } from "@/lib/site";
import { BookLink } from "@/components/site/BookLink";

export function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-40 bg-[#EAD9C6]/95 backdrop-blur-md border-b border-[var(--line)]"
    >
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 h-[68px] flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <img
            src="/assets/seraphina-logo-header.png"
            alt="Seraphina Collective"
            className="h-12 lg:h-16 w-auto object-contain"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={({ isActive }) =>
                `nav-link ${isActive ? "text-[var(--gold)]" : ""}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:block">
          <BookLink
            label="Navbar"
            href={BOOKING_URL}
            data-testid="nav-book-btn"
            className="btn-gold rounded-full px-6 py-3 inline-block"
          >
            Book Appointment
          </BookLink>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-[var(--charcoal)]"
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-[var(--sand)] border-t border-[var(--line)] px-5 py-4">
          <div className="flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className="nav-link text-[0.85rem]"
              >
                {l.label}
              </NavLink>
            ))}
            <BookLink
              label="Mobile Navbar"
              href={BOOKING_URL}
              className="btn-gold rounded-full px-6 py-3 text-center mt-2"
            >
              Book Appointment
            </BookLink>
          </div>
        </div>
      )}
    </header>
  );
}
